<template>
  <div class="box" @touchmove.prevent>
    <remote-script src="http://pv.sohu.com/cityjson?ie=utf-8"></remote-script>

    <div class="paywayBox">
      <div class="payWaytit clearfix">
        <span>确认订单</span>
        <span class="cancelPay fr" @click="offOrder">取消</span>
      </div>
      <div class="orderDel boxSizing clearfix">
        <img :src="popways.cover" class="fl">
        <p class="orderName twoEllipsis" v-text="popways.name"></p>
        <p class="orderPrice">会员专享价 : ￥{{popways.price}}/{{popways.jifen}}积分</p>
      </div>
      <div class="waysBtn boxSizing">
        <p class="waysBtntit">支付方式</p>
        <ul>
          <li @click="changePay()">
            <span>积分支付</span>
            <p class="selects fr" :class="{selected:isselect}">
              <span></span>
            </p>
          </li>
          <li @click="changePay(wxpay)">
            <span>微信支付</span>
            <p class="selects fr" :class="{selected:!isselect}">
              <span></span>
            </p>
          </li>
        </ul>
        <p
          class="payBtn"
          @click="paySubmit(popways.bookId,popways.axiospath,popways.axiospathwx,popways.isWxpay)"
        >立即付款</p>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import qs from "qs";
import common from "../../common.js";
import { setTimeout } from 'timers';
export default {
  name: "payWays",
  props: {
      popways: {
          default: {
              tile: "asdasda"
          }
      }
  },
  data() {
    return {
      isselect: true,
      iswx:false,
      iswxpc:false,
      isIphone:false,
      isAndroid:false,
      wxpay: true,
      WxPackage:null,
    };
  },
  created(){
      let IsOS = navigator.userAgent.toLowerCase();
      this.iswx = IsOS.indexOf("micromessenger") > -1;
      this.iswxpc = IsOS.indexOf("windowswechat") > -1;
      this.isIphone = IsOS.indexOf("iphone") > -1;
      this.isAndroid = IsOS.indexOf("android") > -1 || IsOS.indexOf("linux") > -1;
  },
  mounted(){
  },
  methods: {
    //微信支付，积分支付切换
    changePay: function(wxpay) {
      if (wxpay) {
        this.isselect = false;
      } else {
        this.isselect = true;
      }
    },
    offOrder: function() {
      this.$emit("offPayWay");
      common.move();
    },
    //积分支付
    IntegralPay(url, param){
        axios.post(url, qs.stringify(param)).then((data)=>{
            let res = data.data;
            console.log('积分支付结果：' , res);
            if(res.code == 200){
                param.data = res.data;
                this.Toast({ message: "积分支付成功", position: "center", duration: 2000 });
                this.$emit("offPayWay", param);
            }else{
                this.$emit("offPayWay");
                this.Toast({ message: res.msg, position: "center", duration: 2000 });
            }

        }).catch((err)=>{
            console.log(err);
        });
    },
    //H5调用微信APP支付
    WxH5AppPay(url, param, callback){
        this.$WxH5AppPay(url, param, (res)=>{
            if(res.code == 200){
                //alert(JSON.stringify(res));
                param.data = res.data;
                var path = window.location.href;
                localStorage.setItem("IsPayStatuCodeByH5", "1");
                localStorage.setItem("PayParamsByH5", JSON.stringify(param));
                localStorage.setItem("RedirectPath",path);
                //解决h5支付不刷新
                this.$emit("h5paycallback");

                //解决h5支付不刷新
                location.href = res.data.url;

            }else{
                this.$emit("offPayWay");
                this.Toast({ message: res.msg, position: "center", duration: 2000 });
            }
        });
    },
    //微信内支付
    WxJssdkPay(url, param, callback){
        axios.post(url, qs.stringify(param)).then((data)=>{
            let res = data.data;
            //alert("微信内支付：" + JSON.stringify(res));
            if(res.code === "200"){
                localStorage.setItem("IsPayStatuCode", "1");
                localStorage.setItem("PayParams", JSON.stringify(param));
                window.location.href = res.data.url;
            }else{
                this.$emit("offPayWay",param);
                this.Toast({ message: res.msg, position: "center", duration: 2000 });
            }
        }).catch((err)=>{
            console.log(err);
        });
    },
    //立即支付
    paySubmit(bookId, axiospath, axiospathwx) {
        console.log(bookId); //ip/videoId
        var myIP = returnCitySN.cip;  //获取客户端IP
        bookId.ip = myIP;

        //判断  积分支付
        if (this.isselect) {
            this.IntegralPay(axiospath, bookId);
        }else{
          //判断  微信内支付
          if(this.iswx || this.iswxpc){
              this.WxJssdkPay(axiospathwx,bookId);    //微信内支付
          }else{
              this.WxH5AppPay(axiospathwx, bookId);   //H5App调取微信支付
          }
        }
    }
  }
};
</script>
<style lang="scss" scoped>
.box {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1001;
}
.paywayBox {
  width: 100%;
  height: 784px;
  position: fixed;
  bottom: 0;
  left: 0;
  background: #fff;
  font-size: 28px;
  color: #333;
  .payWaytit {
    height: 94px;
    line-height: 94px;
    text-align: center;
    border-bottom: 1px solid #e1e1e1;
    font-size: 36px;
    .cancelPay {
      position: absolute;
      right: 30px;
      font-size: 24px;
    }
  }
  .orderDel {
    padding: 30px;
    border-bottom: 20px solid #f6f7f8;
    img {
      width: 150px;
      height: 150px;
      margin-right: 30px;
    }
    .orderName {
      font-size: 32px;
      margin: 10px 0 14px;
    }
    .orderPrice {
      color: #ff8b11;
    }
  }
  .waysBtn {
    position: absolute;
    width: 100%;
    height: 460px;
    bottom: 0;
    padding: 0 30px;
    .waysBtntit {
      height: 90px;
      line-height: 100px;
      font-size: 32px;
      border-bottom: 1px solid #e1e1e1;
    }
    li {
      height: 90px;
      line-height: 94px;
      border-bottom: 1px solid #e1e1e1;
    }
    .selects {
      display: block;
      width: 22px;
      height: 22px;
      border-radius: 50%;
      border: 1px solid #999;
      margin-top: 33px;
    }
    .selected {
      span {
        display: block;
        width: 14px;
        height: 14px;
        margin: 2px auto;
        background: #ff8b11;
        border-radius: 50%;
      }
    }
  }
  .payBtn {
    width: 100%;
    height: 88px;
    line-height: 88px;
    text-align: center;
    margin: 76px 0 30px;
    background: #ff8b11;
    color: #fff;
    font-size: 36px;
  }
}
</style>
